// Generated by Melange

import * as Caml from "melange.js/caml.js";
import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_exn from "melange.js/js_exn.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_codec from "./web_codec.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function stop_socket(t) {
  t.generation = t.generation + 1 | 0;
  Stdlib__Option.iter(Mapre_web__Browser.cancel, t.retry);
  t.retry = undefined;
  Stdlib__Option.iter(Mapre_web__Browser.cancel, t.heartbeat);
  t.heartbeat = undefined;
  Stdlib__Option.iter(Mapre_web__Browser.close, t.socket);
  t.socket = undefined;
}

function dispose(t) {
  t.active = false;
  stop_socket(t);
}

function current(t, generation) {
  if (t.active) {
    return t.generation === generation;
  } else {
    return false;
  }
}

function heartbeat(t, generation, socket) {
  t.heartbeat = setTimeout((function (param) {
    if (current(t, generation) && socket.readyState === 1) {
      Mapre_web__Browser.send(socket, "mapre:ping");
      return heartbeat(t, generation, socket);
    }
    
  }), 25000);
}

function connect(t) {
  stop_socket(t);
  if (!t.active) {
    return;
  }
  const generation = t.generation;
  Curry._1(t.status, "Connecting");
  Curry._1(t.authorize, undefined).then(function (allowed) {
    if (current(t, generation) && allowed) {
      open_socket(t, generation);
    }
    return Promise.resolve();
  });
}

function open_socket(t, generation) {
  const origin = Stdlib__String.starts_with("https:", Mapre_web__Browser.origin) ? "wss:" + Stdlib__String.sub(Mapre_web__Browser.origin, 6, Mapre_web__Browser.origin.length - 6 | 0) : "ws:" + Stdlib__String.sub(Mapre_web__Browser.origin, 5, Mapre_web__Browser.origin.length - 5 | 0);
  const socket = new WebSocket(origin + (t.path + ("?after_seq=" + String(Curry._1(t.cursor, undefined)))));
  t.socket = Caml_option.some(socket);
  Mapre_web__Browser.on_open(socket, (function (param) {
    if (current(t, generation)) {
      return heartbeat(t, generation, socket);
    }
    
  }));
  Mapre_web__Browser.on_message(socket, (function (param) {
    if (!current(t, generation)) {
      return;
    }
    const raw = param.data;
    if (raw === "mapre:pong") {
      return;
    }
    try {
      const match = Mapre_web__Web_codec.frame(JSON.parse(raw));
      if (match.TAG === /* Events */ 0) {
        const upto = match._1;
        if (match._0 !== Curry._1(t.cursor, undefined)) {
          throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
              MEL_EXN_ID: Mapre_wire__Json.Invalid,
              _1: "event_cursor_mismatch"
            });
        }
        Curry._2(t.events, upto, match._2);
        t.delay = 500;
        if (socket.readyState === 1) {
          return Mapre_web__Browser.send(socket, JSON.stringify(Js__Js_dict.fromList({
            hd: [
              "v",
              2
            ],
            tl: {
              hd: [
                "type",
                Mapre_wire__Json.str("ack")
              ],
              tl: {
                hd: [
                  "upto",
                  upto
                ],
                tl: /* [] */ 0
              }
            }
          })));
        } else {
          return;
        }
      }
      t.delay = 500;
      return Curry._3(t.controls, match._0, match._1, match._2);
    }
    catch (raw_exn){
      const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
      if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
        dispose(t);
        return Curry._1(t.status, "Event stream invalid. Reload to reconnect.");
      }
      if (exn.MEL_EXN_ID === Js__Js_exn.$$Error) {
        dispose(t);
        return Curry._1(t.status, "Event stream invalid. Reload to reconnect.");
      }
      throw exn;
    }
  }));
  Mapre_web__Browser.on_close(socket, (function ($$event) {
    if (current(t, generation)) {
      if ($$event.code === 1008) {
        dispose(t);
        return Curry._1(t.revoked, undefined);
      } else {
        Curry._1(t.status, "Reconnecting");
        t.retry = setTimeout((function (param) {
          if (current(t, generation)) {
            return connect(t);
          }
          
        }), t.delay);
        t.delay = Caml.caml_int_min(15000, (t.delay << 1));
        return;
      }
    }
    
  }));
}

function create(path, authorize, cursor, events, controls, status, revoked) {
  const t = {
    active: true,
    socket: undefined,
    retry: undefined,
    heartbeat: undefined,
    generation: 0,
    delay: 500,
    authorize,
    cursor,
    events,
    controls,
    status,
    revoked,
    path
  };
  connect(t);
  return t;
}

function reconnect(t) {
  if (t.active) {
    return connect(t);
  }
  
}

export {
  create,
  dispose,
  reconnect,
}
/* Js__Js_exn Not a pure module */
